<template>
  <vue-cookie-accept-decline
    elementId="cookie-banner"
    position="bottom-right"
    :showPostponeButton="true"
    @clicked-decline="decline"
    :debug="false"
  />
</template>

<script>

  import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
  export default {
    name: "CookieBanner",
    methods: {
      decline() {
        _paq.push(['disableCookies']);
        _paq.push(['trackPageView']);
      }
    },
    components: {
      VueCookieAcceptDecline
    }
  }
</script>

<style lang="sass">
  @import "~vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css"
  @import "../../assets/sass/vars"

  #cookie-banner

    .cookie__floating__postpone-button
      padding: 5px 20px 0 0
      margin-left: auto
      margin-right: unset

    .cookie__floating__buttons__button--accept
      color: $colorPrimary

      &:hover
        background-color: $colorPrimary
        color: #FFF

    .cookie__floating__buttons__button--decline
      color: #616b6e

      &:hover
        background-color: #1d2124
        color: #C00

</style>



// WEBPACK FOOTER //
// src/components/layout/CookieBanner.vue